'use client';

import {useMediaQuery} from '@mui/material';

export function Mobile(props: any): JSX.Element | null {
  const matches = useMediaQuery('(max-width:1024px)');

  if (matches) return props.children;
  return null;
}
